import { render, staticRenderFns } from "./CustomerLoyaltySignUp.vue?vue&type=template&id=015daa75&"
import script from "./CustomerLoyaltySignUp.vue?vue&type=script&lang=js&"
export * from "./CustomerLoyaltySignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports